import HttpService from "./HttpService";
const httpService = new HttpService();

import { MINIMUM_OF_USER_FAKE } from "@/const";

export default class UtilsService {
  /**
   * get a stringified date out of a timestamp
   * @param lastPaymentDate
   * @param isTodayIfNull
   * @param fullTextDate
   * @returns
   */
  getDateFromTimestamp: any = (
    lastPaymentDate: number,
    isTodayIfNull: boolean,
    fullTextDate: boolean
  ) => {
    let nextPaymentDate: any = "";
    let options = {};
    if (fullTextDate) {
      options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
    }
    if (lastPaymentDate == null && isTodayIfNull) {
      lastPaymentDate = new Date().getTime();
    }

    const currentFormatedDate = new Date(lastPaymentDate);
    const dateInAYear = currentFormatedDate.setFullYear(
      currentFormatedDate.getFullYear()
    );
    const dateInAYearObj = new Date(dateInAYear);
    nextPaymentDate = dateInAYearObj.toLocaleDateString(undefined, options);

    return nextPaymentDate;
  };

  /**
   *
   * @param lastPaymentDate Timestamp of last payment date
   * @param isTodayIfNull set today's date if first param is null
   * @param fullTextDate return date in full text instead of dd/mm/yyyy or mm/dd/yyyy
   */
  getNextPaymentDate: any = (
    lastPaymentDate: number,
    isTodayIfNull: boolean,
    fullTextDate: boolean
  ) => {
    let nextPaymentDate: any = "";
    let options = {};
    if (fullTextDate) {
      options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
    }
    if (lastPaymentDate == null && isTodayIfNull) {
      lastPaymentDate = new Date().getTime();
    }

    const currentFormatedDate = new Date(lastPaymentDate);
    // const dateInAYear = currentFormatedDate.setFullYear(
    //   currentFormatedDate.getFullYear() + 1
    // );
    // const dateInAYearObj = new Date(dateInAYear);
    nextPaymentDate = currentFormatedDate.toLocaleDateString(
      undefined,
      options
    );
    // nextPaymentDate = dateInAYearObj.toLocaleDateString(undefined, options);

    return nextPaymentDate;
  };

  /**
   * Get the number of users
   * @param fake either we have to fake it or no
   * @returns
   */
  getNumberOfUsers = async (fake: boolean) => {
    console.log("getNumberOfUsers", fake);
    return await httpService
      .fetch("GET", "api/user/count", {})
      .then((userCount) => {
        console.log("userCount");
        if (fake && userCount < MINIMUM_OF_USER_FAKE) {
          return userCount + MINIMUM_OF_USER_FAKE;
        } else {
          return userCount;
        }
      });
  };

  /**
   * Remove accents and special characters from a strinf
   * @param text
   * @returns
   */
  sanitizeString = (text: string) => {
    console.log("sanitize", text);
    const sanitized = text.normalize("NFD").replace(/\p{Diacritic}/gu, "");
    console.log("sanitized", sanitized);
    return sanitized;
  };
}
